firebird.factory('onboardingService', [
    '$window',
    '$rootScope',
    'config',
    'helperService',
    'logService',
    'localizationService',
    function ($window, $rootScope, config, helperService, logService, localizationService) {
        let appCuesStarted = false;
        let appCuesModalOpen = false;
        const meetingSidebarFlowId = '-KvZo5QKUVQjpnOv6KWn'; //Appcues Flow: 'Attendee List, Chat, Notes'
        const webinarSidebarFlowId = '-KvZZDoKHj3DKa2S-NEX'; //Appcues Flow: 'Attendee List, Chat, Notes (Webinar)'

        const topControlsMeetingFlowId = '-KvZo0kVMjKB2dxFItK-'; //Appcues Flow: 'Top Controls - Pro'

        const firstWebinarFlowId = '-KvZYEE1QxsBpIcSoMs_'; //Appcues Flow: '1. Welcome to your first webinar'

        const tutorialFlowId = '-M2oKI574HqGrY_yC5d3'; //Appcues Flow: 'Welcome to your first meeting!''

        const ThemeFeaturesFlowId = 'd3bc256a-36d6-4ef3-8032-8ce857976d61'; //AppCues Flow: 'Theme AM intro'
        let ThemeFeaturesFlowShown = false;

        const service = {
            appCuesIdentify: appCuesIdentify,
            startAppCues: startAppCues,
            initListeners: initListeners,
            hasAppCuesStarted: hasAppCuesStarted,
            isAppCuesModalOpen: isAppCuesModalOpen,
            leftSidebarInitiallyOpen: false,
            showTutorial: showTutorial,
            showWebinarsTutorial: showWebinarsTutorial,
            showThemeFeaturesFlow: showThemeFeaturesFlow
        };

        return service;

        ////////////////////////

        function appCuesIdentify(isHost, onboardingInfo) {
            if ($window.Appcues) {
                if (!onboardingInfo) {
                    $window.Appcues.anonymous();
                    return;
                }

                onboardingInfo.host = isHost;
                onboardingInfo.Language = localizationService.getLocalization();

                if (config && config.version) {
                    var majorReleaseVersion = config.version.match(/^\d+/);

                    if (majorReleaseVersion) {
                        onboardingInfo.anymeetingClientVersion = parseInt(majorReleaseVersion[0]);
                    } else {
                        logService.log('appCuesIdentify could not set anymeetingClientVersion with: ' + config.version);
                    }
                } else {
                    logService.log('appCuesIdentify could not set anymeetingClientVersion missing config.version');
                }

                $window.Appcues.identify(onboardingInfo.email, onboardingInfo);
            }
        }

        function startAppCues() {
            if ($window.Appcues) {
                $window.Appcues.start();
            }
        }

        function initListeners() {
            if ($window.Appcues) {
                $window.Appcues.on('flow_completed', function (eventData) {
                    appCuesModalOpen = false;
                    if (eventData.flowId === meetingSidebarFlowId || eventData.flowId === webinarSidebarFlowId) {
                        if (!service.leftSidebarInitiallyOpen) {
                            $rootScope.$broadcast('toggle-left-sidebar', 'closed');
                        }
                    }

                    if (eventData.flowId === topControlsMeetingFlowId) {
                        $rootScope.$broadcast('top-controls-onboarding-finished');
                    }

                    if (helperService.getIsRedesign()) {
                        $rootScope.$broadcast('enable-header-auto-hide', { enable: true, reason: 'onboarding' });
                    }
                });

                $window.Appcues.on('flow_started', function (eventData) {
                    if (!appCuesStarted) {
                        appCuesStarted = true;

                        if (helperService.getIsRedesign()) {
                            $rootScope.$broadcast('enable-header-auto-hide', { enable: false, reason: 'onboarding' });
                        }
                    }

                    if (eventData.flowId === meetingSidebarFlowId || eventData.flowId === webinarSidebarFlowId) {
                        service.leftSidebarInitiallyOpen = $window.$('#sidebar-left').hasClass('toggled');
                        if (!service.leftSidebarInitiallyOpen) {
                            $rootScope.$broadcast('toggle-left-sidebar', 'open');
                        }
                    }

                    if (eventData.flowId === topControlsMeetingFlowId) {
                        $rootScope.$broadcast('top-controls-onboarding-started');
                    }
                });

                //This event gets fired when user clicks "hide these tips", which ends the onboarding flow
                //but doesn't trigger "flow_completed"
                $window.Appcues.on('flow_skipped', function () {
                    appCuesModalOpen = false;
                    if (helperService.getIsRedesign()) {
                        logService.log('Redesign Onboarding flow skipped');
                        $rootScope.$broadcast('enable-header-auto-hide', { enable: true, reason: 'onboarding' });
                    }
                });
            }
        }

        function hasAppCuesStarted() {
            return appCuesStarted;
        }

        function isAppCuesModalOpen() {
            return appCuesModalOpen;
        }

        function showTutorial() {
            if ($window.Appcues) {
                appCuesStarted = false;
                $window.Appcues.show(tutorialFlowId);
            }
        }

        function showWebinarsTutorial() {
            if ($window.Appcues) {
                appCuesStarted = false;
                $window.Appcues.show(firstWebinarFlowId);
            }
        }

        function showThemeFeaturesFlow() {
            if ($window.Appcues && !ThemeFeaturesFlowShown) {
                appCuesStarted = false;
                appCuesModalOpen = true;
                $window.Appcues.show(ThemeFeaturesFlowId);
                ThemeFeaturesFlowShown = true;
            }
        }
    }
]);
